export enum ExternalGoodsType {
    CARGO_MATERIAL = "CARGO_MATERIAL",
    CARGO_EMPTIES = "CARGO_EMPTIES",
    BULK_DRY = "BULK_DRY",
    BULK_LIQUID = "BULK_LIQUID",
}

export type ExternalGoods = ExternalCargoMaterialGoods | ExternalCargoEmptiesGoods | ExternalBulkDryGoods | ExternalBulkLiquidGoods

export type ExternalCargoMaterialGoods = {
    type: ExternalGoodsType.CARGO_MATERIAL
    handling_units: Array<ExternalHandlingUnit>
}

export type ExternalCargoEmptiesGoods = {
    type: ExternalGoodsType.CARGO_EMPTIES
    handling_units: Array<ExternalHandlingUnitEmpties>
}

export type ExternalBulkDryGoods = {
    type: ExternalGoodsType.BULK_DRY
    article_id?: string
    dangerous_goods_information?: ExternalDangerousGoodsInformation
    volume_m3?: number
    weight_kg?: number
}

export type ExternalBulkLiquidGoods = {
    type: ExternalGoodsType.BULK_LIQUID
    article_id?: string
    dangerous_goods_information?: ExternalDangerousGoodsInformation
    volume_m3?: number
    weight_kg?: number
}

export interface ExternalWeight {
    gross_weight_kg?: number
}

export interface ExternalDangerousGoodsInformation {
    undg?: string
    description?: string
    exception_regulation?: string
    hazard_class?: ExternalHazardClass,
    packing_group?: ExternalPackingGroup,
    tunnel_restriction_code?: ExternalTunnelRestrictionCode,
}

export enum ExternalHazardClass {
    CLASS_1_1 = "1.1",
    CLASS_1_2 = "1.2",
    CLASS_1_3 = "1.3",
    CLASS_1_4 = "1.4",
    CLASS_1_5 = "1.5",
    CLASS_1_6 = "1.6",
    CLASS_2_1 = "2.1",
    CLASS_2_2 = "2.2",
    CLASS_2_3 = "2.3",
    CLASS_3 = "3",
    CLASS_4_1 = "4.1",
    CLASS_4_2 = "4.2",
    CLASS_4_3 = "4.3",
    CLASS_5_1 = "5.1",
    CLASS_5_2 = "5.2",
    CLASS_6_1 = "6.1",
    CLASS_6_2 = "6.2",
    CLASS_7 = "7",
    CLASS_8 = "8",
    CLASS_9 = "9",
}

export enum ExternalPackingGroup {
    I = "I",
    II = "II",
    III = "III",
}

export enum ExternalTunnelRestrictionCode {
    NONE = "-",
    B = "B",
    B1000C = "B1000C",
    B_D = "B/D",
    B_E = "B/E",
    C = "C",
    C5000D = "C5000D",
    C_D = "C/D",
    C_E = "C/E",
    D = "D",
    D_E = "D/E",
    E = "E",
}

export interface ExternalCountryOfOrigin {
    country_code?: string
    dutiable_goods: boolean
}

export type ExternalArticle = {
    internal_place_of_destination: { id?: string }
    net_explosive_mass_kg?: number
    type: ExternalPackableType.ARTICLE
    id?: string
    quantity?: { value: number }
    dangerous_goods_information?: ExternalDangerousGoodsInformation
    country_of_origin?: ExternalCountryOfOrigin
}

export type ExternalHandlingUnit = {
    type: ExternalPackableType.HANDLING_UNIT
    content: Array<ExternalPackable>
    weight?: ExternalWeight
    dimension?: ExternalDimension
    quantity?: number
    packaging_code?: string
    stacking_factor?: number
}

export type ExternalArticleEmpties = {
    id?: string
    quantity: number
    dangerous_goods_information?: ExternalDangerousGoodsInformation
}

export type ExternalHandlingUnitEmpties = {
    content: Array<ExternalArticleEmpties>
    gross_weight_kg?: number
    dimension?: ExternalDimension
    quantity?: number
    packaging_code?: string
    stacking_factor?: number
}

export enum ExternalPackableType {
    ARTICLE = "ARTICLE",
    HANDLING_UNIT = "HANDLING_UNIT",
}

export type ExternalPackable = ExternalHandlingUnit | ExternalArticle


export interface ExternalDimension {
    length_m?: number
    width_m?: number
    height_m?: number
}
